import Main from '@/components/verify/Main';
import RouteList from '@/components/verify/RouteList';
import SiteListCompo from '@/components/verify/SiteListCompo';
import { Divider, Typography } from '@mui/material';
import styled from 'styled-components';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  padding: 2rem;
  overflow-y: hidden;
`;

const SubWrap = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem 0;
  overflow-y: hidden;
  display: flex;
  gap: 1.5rem;
  > div:first-child {
    padding: 0.5rem 0;
    width:15rem;
    max-width:15rem;
    min-width: 15rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
  }
  > div:last-child {
    border-left: 1px solid #bbbbbb;
    padding: 0 1.5rem;
    width: calc(100% - 15rem - 1.5rem);
    flex-grow:1;
    height: 100%;
  }
`;

export default function VerifyTemplate() {
  return (
    <MainWrap>
      <Typography variant="h5">AI SHIPPING DATA VERIFY</Typography>
      <Divider />
      <SubWrap>
        <div>
          <SiteListCompo />
          <RouteList />
        </div>
        <div>
          <Main />
        </div>
      </SubWrap>
    </MainWrap>
  );
}
